import React from "react";
import { Box, Typography } from "@mui/material";
import { FieldProps } from "@/core/components/Field";
import { LOADER_COLOR, LOADER_SIZE, MaterialColors } from "@/core/types/types";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";

interface CustomLoaderProps {
  loaderSize?: number;
  loaderColor?: MaterialColors;
}

const styles = () => ({
  loader: {
    textIndent: "-9999em",
    overflow: "hidden",
    margin: "inherit",
    width: "1em",
    height: "1em",
    borderRadius: "50%",
    position: "relative",
    transform: "translateZ(0)",
    animation: "$mltShdSpin 1.7s infinite ease, $round 1.7s infinite ease",
  },
  "@keyframes mltShdSpin": {
    "0%": {
      boxShadow:
        "0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em",
    },
    "5%, 95%": {
      boxShadow:
        "0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em",
    },
    "10%, 59%": {
      boxShadow:
        "0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em",
    },
    "20%": {
      boxShadow:
        "0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em",
    },
    "38%": {
      boxShadow:
        "0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em",
    },
    "100%": {
      boxShadow:
        "0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em",
    },
  },
  "@keyframes round": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
});

const SolarSystem = ({ loaderColor, loaderSize = 40 }: CustomLoaderProps) => {
  const classes: any = useCustomStyles(styles);
  return (
    <Box sx={{ margin: "0 auto" }}>
      <Typography
        color={loaderColor}
        fontSize={Number(loaderSize)}
        my={2}
        sx={classes?.loader}
      ></Typography>
    </Box>
  );
};

const CustomLoader = ({ field }: FieldProps) => {
  const loaderColor: MaterialColors | undefined =
    field.properties?.[LOADER_COLOR];
  const loaderSize: number | undefined = field.properties?.[LOADER_SIZE];

  return <SolarSystem loaderColor={loaderColor} loaderSize={loaderSize} />;
};

export default CustomLoader;
